export class DeleteRestoreAccountV1Request {
    'forceDelete';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "forceDelete",
            "baseName": "forceDelete",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DeleteRestoreAccountV1Request.attributeTypeMap;
    }
    constructor() {
    }
}
